export interface PaginationMeta {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
}

export interface ApiResponse<T> {
  data: T;
  meta?: PaginationMeta;
}

export interface ApiError {
  message: string;
  errors?: Record<string, string[]>;
  requiresVerification?: boolean;
  credentialType?: string;
}

export class ApiRequestError extends Error {
  status: number;
  errors?: Record<string, string[]>;
  requiresVerification?: boolean;
  credentialType?: string;

  constructor(
    status: number,
    message: string,
    errors?: Record<string, string[]>,
    requiresVerification?: boolean,
    credentialType?: string,
  ) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
    this.errors = errors;
    this.requiresVerification = requiresVerification;
    this.credentialType = credentialType;
  }
}
